import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetCenterCaseAssertionDescriptors = (caseGroupGuid: string | undefined) => {
    return useQuery({
        queryKey: ['get-center-case-assertion-descriptors', caseGroupGuid],
        queryFn: async () => {
            if (!caseGroupGuid) {
                return;
            }
            
            const response = await _apiClient.getCenterCaseAssertionDescriptors(caseGroupGuid);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve center case assertion descriptors.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: !!caseGroupGuid,
    });
};
